// TODO: 联调时替换为接口数据
// 物模型共享数据层 —— 类目 / 能力模块 / 标准能力 / 类目-能力关联

let _id = 0;
const nextId = () => ++_id;

// ===== 类目 =====
const initialCategories = [
  { id: nextId(), name: 'IPC摄像机', identifier: 'IpcCamera', descr: 'IPC摄像机设备类目，包含视频监控、事件侦测相关能力' },
  { id: nextId(), name: '智能门铃', identifier: 'SmartDoorbell', descr: '智能门铃设备类目，包含门铃呼叫、门锁联动相关能力' },
  { id: nextId(), name: '传感安防', identifier: 'SensorSecurity', descr: '传感器和安防设备类目，包含环境监测和安防告警能力' },
];

// ===== 能力模块 =====
const initialModules = [
  { id: nextId(), name: '工作模式模块', identifier: 'WorkModeModule' },
  { id: nextId(), name: '录制模式模块', identifier: 'RecordModeModule' },
  { id: nextId(), name: '灯光模式模块', identifier: 'LightModeModule' },
  { id: nextId(), name: '事件侦测模块', identifier: 'EventDetectModule' },
  { id: nextId(), name: '门铃设置模块', identifier: 'BellSettingModule' },
  { id: nextId(), name: '安防侦测模块', identifier: 'SecurityDetectModule' },
];

// ===== 标准能力池 =====
const initialCapabilities = [
  // 工作模式模块 (moduleId: 1)
  { id: nextId(), moduleId: 1, capType: 'prop', name: '工作模式', identifier: 'WorkMode',
    descr: '设备工作模式切换（低功耗/AOV/长电/自定义）',
    dataDef: { dataType: 'enum', accessMode: 'rw', enumValues: [{ name: '低功耗模式', val: 0 }, { name: 'AOV模式', val: 1 }, { name: '长电模式', val: 2 }, { name: '自定义模式', val: 3 }], defaultVal: '0' } },
  { id: nextId(), moduleId: 1, capType: 'prop', name: 'AOV拍照帧率', identifier: 'AovCaptureFrameRate',
    descr: 'AOV模式下拍照的时间间隔',
    dataDef: { dataType: 'int', accessMode: 'rw', min: 1, max: 10, step: 1, unit: '秒/帧', defaultVal: '1' } },
  { id: nextId(), moduleId: 1, capType: 'prop', name: 'AOV切换低功耗电量', identifier: 'AovAutoSwitchPower',
    descr: 'AOV模式下自动切换到低功耗的电量阈值',
    dataDef: { dataType: 'int', accessMode: 'rw', min: 0, max: 100, step: 1, unit: '%', defaultVal: '30' } },
  // 录制模式模块 (moduleId: 2)
  { id: nextId(), moduleId: 2, capType: 'prop', name: '常规录制', identifier: 'NormalRecord',
    descr: '常规录制模式设置（全天/自定义/关闭）',
    dataDef: { dataType: 'enum', accessMode: 'rw', enumValues: [{ name: '全天', val: 0 }, { name: '自定义时段', val: 1 }, { name: '关闭', val: 2 }], defaultVal: '0' } },
  { id: nextId(), moduleId: 2, capType: 'prop', name: '事件录制', identifier: 'EventRecord',
    descr: '是否开启事件触发录制',
    dataDef: { dataType: 'boolean', accessMode: 'rw', trueLabel: '开启', falseLabel: '关闭', defaultVal: '1' } },
  { id: nextId(), moduleId: 2, capType: 'prop', name: '录制清晰度', identifier: 'RecordResolution',
    descr: '录制视频清晰度等级',
    dataDef: { dataType: 'enum', accessMode: 'rw', enumValues: [{ name: '超清', val: 0 }, { name: '高清', val: 1 }, { name: '标清', val: 2 }], defaultVal: '1' } },
  { id: nextId(), moduleId: 2, capType: 'prop', name: '抓拍间隔', identifier: 'CaptureInterval',
    descr: '事件触发时连续抓拍的时间间隔',
    dataDef: { dataType: 'int', accessMode: 'rw', min: 100, max: 10000, step: 100, unit: 'ms', defaultVal: '500' } },
  { id: nextId(), moduleId: 2, capType: 'prop', name: '事件录制时长', identifier: 'EventRecordDuration',
    descr: '事件触发后单次录制时长',
    dataDef: { dataType: 'int', accessMode: 'rw', min: 5, max: 300, step: 5, unit: '秒', defaultVal: '30' } },
  { id: nextId(), moduleId: 2, capType: 'svc', name: '格式化存储', identifier: 'FormatStorage',
    descr: '远程格式化设备存储卡',
    dataDef: { dataType: 'service', inputParams: [], outputParams: [{ name: '操作结果', identifier: 'result', dataType: 'boolean', trueLabel: '成功', falseLabel: '失败', defaultVal: '1' }] } },
  // 灯光模式模块 (moduleId: 3)
  { id: nextId(), moduleId: 3, capType: 'prop', name: '灯光模式', identifier: 'LightMode',
    descr: '灯光模式切换（全彩/红外/智能/自定义/关闭）',
    dataDef: { dataType: 'enum', accessMode: 'rw', enumValues: [{ name: '全彩模式', val: 0 }, { name: '红外模式', val: 1 }, { name: '智能模式', val: 2 }, { name: '自定义模式', val: 3 }, { name: '关闭', val: 4 }], defaultVal: '1' } },
  // 事件侦测模块 (moduleId: 4)
  { id: nextId(), moduleId: 4, capType: 'evt', name: '移动侦测', identifier: 'MotionDetect',
    descr: '设备检测到物体移动时上报告警事件',
    dataDef: { dataType: 'event', eventType: 'alarm', outputParams: [] } },
  { id: nextId(), moduleId: 4, capType: 'evt', name: '电量不足告警', identifier: 'LowBattery',
    descr: '设备电量低于阈值时上报',
    dataDef: { dataType: 'event', eventType: 'alarm', outputParams: [{ name: '当前电量', identifier: 'battery', dataType: 'int', min: 0, max: 100, step: 1, unit: '%', defaultVal: '0' }] } },
  { id: nextId(), moduleId: 4, capType: 'evt', name: '设备上线通知', identifier: 'DeviceOnline',
    descr: '设备从离线变为在线时上报',
    dataDef: { dataType: 'event', eventType: 'info', outputParams: [] } },
  // 门铃设置模块 (moduleId: 5)
  { id: nextId(), moduleId: 5, capType: 'prop', name: '门铃音量', identifier: 'BellVolume',
    descr: '门铃音量大小设置',
    dataDef: { dataType: 'int', accessMode: 'rw', min: 0, max: 100, step: 5, unit: '%', defaultVal: '50' } },
  { id: nextId(), moduleId: 5, capType: 'prop', name: '门铃铃声', identifier: 'BellRingtone',
    descr: '门铃铃声选择',
    dataDef: { dataType: 'enum', accessMode: 'rw', enumValues: [{ name: '经典铃声', val: 0 }, { name: '柔和铃声', val: 1 }, { name: '轻快铃声', val: 2 }], defaultVal: '0' } },
  { id: nextId(), moduleId: 5, capType: 'svc', name: '远程开门', identifier: 'RemoteUnlock',
    descr: '远程控制门锁开启',
    dataDef: { dataType: 'service', inputParams: [], outputParams: [{ name: '开门结果', identifier: 'result', dataType: 'boolean', trueLabel: '成功', falseLabel: '失败', defaultVal: '1' }] } },
  { id: nextId(), moduleId: 5, capType: 'evt', name: '门铃呼叫', identifier: 'BellRing',
    descr: '访客按下门铃时上报',
    dataDef: { dataType: 'event', eventType: 'info', outputParams: [] } },
  // 安防侦测模块 (moduleId: 6)
  { id: nextId(), moduleId: 6, capType: 'prop', name: '告警灵敏度', identifier: 'AlarmSensitivity',
    descr: '安防告警的触发灵敏度',
    dataDef: { dataType: 'enum', accessMode: 'rw', enumValues: [{ name: '高', val: 0 }, { name: '中', val: 1 }, { name: '低', val: 2 }], defaultVal: '1' } },
  { id: nextId(), moduleId: 6, capType: 'evt', name: '烟雾告警', identifier: 'SmokeAlarm',
    descr: '检测到烟雾时上报',
    dataDef: { dataType: 'event', eventType: 'alarm', outputParams: [] } },
  { id: nextId(), moduleId: 6, capType: 'evt', name: '水浸告警', identifier: 'WaterLeak',
    descr: '检测到水浸时上报',
    dataDef: { dataType: 'event', eventType: 'alarm', outputParams: [] } },
];

// ===== 类目-能力关联 =====
const initialCategoryCaps = [
  { categoryId: 1, capabilityId: 1 }, { categoryId: 1, capabilityId: 2 },
  { categoryId: 1, capabilityId: 3 }, { categoryId: 1, capabilityId: 4 },
  { categoryId: 1, capabilityId: 5 }, { categoryId: 1, capabilityId: 6 },
  { categoryId: 1, capabilityId: 7 }, { categoryId: 1, capabilityId: 8 },
  { categoryId: 1, capabilityId: 9 }, { categoryId: 1, capabilityId: 10 },
  { categoryId: 1, capabilityId: 11 }, { categoryId: 1, capabilityId: 12 },
  { categoryId: 1, capabilityId: 13 },
  { categoryId: 2, capabilityId: 14 }, { categoryId: 2, capabilityId: 15 },
  { categoryId: 2, capabilityId: 16 }, { categoryId: 2, capabilityId: 17 },
  { categoryId: 2, capabilityId: 11 }, { categoryId: 2, capabilityId: 12 },
  { categoryId: 2, capabilityId: 13 },
  { categoryId: 3, capabilityId: 18 }, { categoryId: 3, capabilityId: 19 },
  { categoryId: 3, capabilityId: 20 }, { categoryId: 3, capabilityId: 11 },
  { categoryId: 3, capabilityId: 12 }, { categoryId: 3, capabilityId: 13 },
];

// ===== 初始化克隆 =====
let categories = JSON.parse(JSON.stringify(initialCategories));
let modules = JSON.parse(JSON.stringify(initialModules));
let capabilities = JSON.parse(JSON.stringify(initialCapabilities));
let categoryCaps = JSON.parse(JSON.stringify(initialCategoryCaps));

// 企业级自定义能力存储: { [enterpriseId]: { modules, capabilities } }
let enterpriseData = {};

function getEnterpriseData(enterpriseId) {
  if (!enterpriseData[enterpriseId]) {
    enterpriseData[enterpriseId] = {
      modules: [
        { id: `${enterpriseId}-m1`, name: '自定义模块1', identifier: 'customMod1' },
      ],
      capabilities: [
        { id: `${enterpriseId}-c1`, moduleId: `${enterpriseId}-m1`, capType: 'prop', name: '客流人数统计', identifier: 'CalcSwitch',
          descr: '自定义客流统计开关',
          dataDef: { dataType: 'boolean', accessMode: 'rw', trueLabel: '开启', falseLabel: '关闭', defaultVal: '0' } },
        { id: `${enterpriseId}-c2`, moduleId: `${enterpriseId}-m1`, capType: 'prop', name: '客流统计间隔', identifier: 'CalcInterval',
          descr: '客流人数统计时间间隔',
          dataDef: { dataType: 'int', accessMode: 'rw', min: 0, max: 60, step: 1, unit: '秒', defaultVal: '30' } },
      ],
    };
  }
  return enterpriseData[enterpriseId];
}

// ===== 导出 getter =====
export function getCategories() { return categories; }
export function getModules() { return modules; }
export function getCapabilities() { return capabilities; }
export function getCategoryCaps() { return categoryCaps; }
export function getEnterpriseModules(entId) { return getEnterpriseData(entId).modules; }
export function getEnterpriseCapabilities(entId) { return getEnterpriseData(entId).capabilities; }

// ===== 类目操作 =====
export function addCategory(item) {
  const cat = { id: nextId(), name: item.name, identifier: item.identifier, descr: item.descr || '' };
  categories.push(cat);
  return cat;
}
export function updateCategory(id, item) {
  const cat = categories.find(c => c.id === id);
  if (cat) { cat.name = item.name; cat.identifier = item.identifier; cat.descr = item.descr; }
}
export function removeCategory(id) {
  categories = categories.filter(c => c.id !== id);
  categoryCaps = categoryCaps.filter(cc => cc.categoryId !== id);
}
export function isCategoryIdentifierUnique(identifier, excludeId) {
  return !categories.some(c => (excludeId && c.id === excludeId) ? false : c.identifier === identifier);
}
export function getCategoryCapCount(categoryId) {
  return categoryCaps.filter(cc => cc.categoryId === categoryId).length;
}
export function getCategoryLinkedCapIds(categoryId) {
  return categoryCaps.filter(cc => cc.categoryId === categoryId).map(cc => cc.capabilityId);
}
export function linkCapToCategory(categoryId, capabilityId) {
  if (!categoryCaps.some(cc => cc.categoryId === categoryId && cc.capabilityId === capabilityId)) {
    categoryCaps.push({ categoryId, capabilityId });
  }
}
export function unlinkCapFromCategory(categoryId, capabilityId) {
  categoryCaps = categoryCaps.filter(cc => !(cc.categoryId === categoryId && cc.capabilityId === capabilityId));
}

// ===== 模块操作 =====
export function addModule(item) {
  const mod = { id: nextId(), name: item.name, identifier: item.identifier };
  modules.push(mod);
  return mod;
}
export function updateModule(id, item) {
  const mod = modules.find(m => m.id === id);
  if (mod) { mod.name = item.name; mod.identifier = item.identifier; }
}
export function removeModule(id) {
  capabilities = capabilities.filter(c => c.moduleId !== id);
  categoryCaps = categoryCaps.filter(cc => {
    const cap = capabilities.find(c => c.id === cc.capabilityId);
    return !!cap;
  });
  modules = modules.filter(m => m.id !== id);
}
export function isModuleIdentifierUnique(identifier, excludeId) {
  return !modules.some(m => (excludeId && m.id === excludeId) ? false : m.identifier === identifier);
}

// ===== 能力操作 =====
export function addCapability(item) {
  const cap = { id: nextId(), moduleId: item.moduleId, capType: item.capType, name: item.name, identifier: item.identifier, descr: item.descr || '', dataDef: item.dataDef };
  capabilities.push(cap);
  return cap;
}
export function updateCapability(id, item) {
  const cap = capabilities.find(c => c.id === id);
  if (cap) {
    cap.moduleId = item.moduleId; cap.capType = item.capType;
    cap.name = item.name; cap.identifier = item.identifier;
    cap.descr = item.descr; cap.dataDef = item.dataDef;
  }
}
export function removeCapability(id) {
  capabilities = capabilities.filter(c => c.id !== id);
  categoryCaps = categoryCaps.filter(cc => cc.capabilityId !== id);
}
export function isCapIdentifierUnique(identifier, excludeId) {
  return !capabilities.some(c => (excludeId && c.id === excludeId) ? false : c.identifier === identifier);
}
export function getCapWithModule(capId) {
  const cap = capabilities.find(c => c.id === capId);
  if (!cap) return null;
  const mod = modules.find(m => m.id === cap.moduleId);
  return { ...cap, _moduleName: mod ? mod.name : '—' };
}

// ===== 企业自定义能力操作 =====
export function addEnterpriseModule(entId, item) {
  const data = getEnterpriseData(entId);
  const mod = { id: `${entId}-m${Date.now()}`, name: item.name, identifier: item.identifier };
  data.modules.push(mod);
  return mod;
}
export function updateEnterpriseModule(entId, modId, item) {
  const data = getEnterpriseData(entId);
  const mod = data.modules.find(m => m.id === modId);
  if (mod) { mod.name = item.name; mod.identifier = item.identifier; }
}
export function removeEnterpriseModule(entId, modId) {
  const data = getEnterpriseData(entId);
  data.capabilities = data.capabilities.filter(c => c.moduleId !== modId);
  data.modules = data.modules.filter(m => m.id !== modId);
}
export function isEnterpriseModuleIdentifierUnique(entId, identifier, excludeId) {
  const data = getEnterpriseData(entId);
  return !data.modules.some(m => (excludeId && m.id === excludeId) ? false : m.identifier === identifier);
}

export function addEnterpriseCapability(entId, item) {
  const data = getEnterpriseData(entId);
  const cap = { id: `${entId}-c${Date.now()}`, moduleId: item.moduleId, capType: item.capType, name: item.name, identifier: item.identifier, descr: item.descr || '', dataDef: item.dataDef };
  data.capabilities.push(cap);
  return cap;
}
export function updateEnterpriseCapability(entId, capId, item) {
  const data = getEnterpriseData(entId);
  const cap = data.capabilities.find(c => c.id === capId);
  if (cap) {
    cap.moduleId = item.moduleId; cap.capType = item.capType;
    cap.name = item.name; cap.identifier = item.identifier;
    cap.descr = item.descr; cap.dataDef = item.dataDef;
  }
}
export function removeEnterpriseCapability(entId, capId) {
  const data = getEnterpriseData(entId);
  data.capabilities = data.capabilities.filter(c => c.id !== capId);
}
export function isEnterpriseCapIdentifierUnique(entId, identifier, excludeId) {
  const data = getEnterpriseData(entId);
  return !data.capabilities.some(c => (excludeId && c.id === excludeId) ? false : c.identifier === identifier);
}

// ===== 工具函数 =====
export const TYPE_LABEL = { prop: '属性', svc: '服务', evt: '事件' };
export const TYPE_COLOR = { prop: { bg: '#EFF6FF', color: '#2563EB' }, svc: { bg: '#F0FDF4', color: '#16A34A' }, evt: { bg: '#FFFBEB', color: '#D97706' } };
export const DATA_TYPE_OPTIONS = [
  { value: 'enum', label: '枚举型 (Enum)' },
  { value: 'int', label: '数值型 (Int)' },
  { value: 'boolean', label: '布尔型 (Boolean)' },
  { value: 'string', label: '字符串 (String)' },
];
export const PARAM_TYPE_OPTIONS = [
  { value: 'int', label: 'Int (数字)' },
  { value: 'string', label: 'String (字符串)' },
  { value: 'boolean', label: 'Boolean (布尔)' },
  { value: 'enum', label: 'Enum (枚举)' },
];
export const IDENT_REGEX = /^[a-zA-Z][a-zA-Z0-9_]*$/;
